// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
import { createSubscriber, createContainer, createHook } from '@atlassian/react-sweet-state';
import type { Actions } from './actions/index.tsx';
import Store from './basket.tsx';
import type { State, Props } from './types.tsx';

// eslint-disable-next-line @atlassian/eng-health/no-barrel-files/disallow-reexports
export { default } from './basket';

export const ConnectAppsSubscriber = createSubscriber<State, Actions>(Store, {
	displayName: 'ConnectAppsSubscriber',
});

export const useConnectApps = createHook(Store);

export const ConnectAppsContainer = createContainer<State, Actions, Props>(Store);
